<template>
  <div>
    <!-- BEGIN CONTENT BODY -->
    <!-- BEGIN PAGE HEADER-->
    <breadcrumb-bar
        :crumbs="[{name:'Workspace', link:'Workspace'},{name:'Organization Forms'}]"></breadcrumb-bar>
    <!--END PAGE HEADER-->
    <div class="row">
      <div class="col-md-8">
        <div class="row">
          <div class="col-md-12">
            <general-forms type="organization_general"></general-forms>
          </div>
        </div>
      </div>
    </div>
    <!--END CONTENT BODY-->
  </div>
</template>
<script>
  import Widget from '@/components/widgets/Widget.vue';
  import FORM from '@/components/widgets/FormCRUD';
  import Breadcrumbs from '@/components/Breadcrumbs'
  import {mapActions} from 'vuex';
  export default {

    data() {
      return {}
    },

    methods: {
      ...mapActions([
        'loadWorkspace'
      ]),
    },

    components: {
      'general-forms': FORM,
      'breadcrumb-bar': Breadcrumbs
    }


  }
</script>



// WEBPACK FOOTER //
// GeneralForms.vue?c85b54ce